import { Controller } from "@hotwired/stimulus"

// Strip non-digits from the input value as the user types or pastes.
// Pareia com pattern="\d*" + inputmode="numeric" — esses dão hint visual e
// validação no submit; este controller força o conteúdo em tempo real.
export default class extends Controller {
  connect() {
    this.handler = this.strip.bind(this)
    this.element.addEventListener("input", this.handler)
  }

  disconnect() {
    this.element.removeEventListener("input", this.handler)
  }

  strip(event) {
    const cleaned = event.target.value.replace(/\D/g, "")
    if (cleaned !== event.target.value) {
      event.target.value = cleaned
    }
  }
}
